/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Col, Row, Container, Tooltip, Accordion, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as action from './Store/SystemMasters.action';
import './SystemMasters.css';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import SampleTracking from './SampleTracking/SampleTracking';
import SampleStatus from './SampleStatus/SampleStatus';
import MeasurementMaster from './MeasurementMaster/MeasurementMaster';
import BrandMaster from './brandmaster';
import SeasonMaster from './seasonmaster';
import TestTypeMaster from './TestTypeMaster';
import Category1Master from './Category1Master';
import Category2Master from './Category2Master';
import LengthMaster from './lengthMaster';
import OtherSampleMaster from './othersamplemaster';
import POSizeMaster from './posizemaster';
import UnitsMaster from './Unitsmaster';
import CustomAttributeMaster from './CustomAttributeMaster/CustomAttributeMaster';
import PartnerOverviewCustomAttributes from './PartnerOverviewCustomAttributes/PartnerOverviewCustomAttributes';
import CompositionMaster from './compositionmaster';
import MainSamplesMaster from './MainSamplesMaster';
import ProductStatusMaster from './productstatusmaster';
import BomSubTypeMaster from './BomSubTypeMaster';
import BomSubComponentTypeMaster from './BOMSubComponentType';
import Category3Master from './category3master';
import Category4Master from './category4master';
import ProductComponentTypeMaster from './ProductComponentTypeMaster';
import FinalMaster from './finalmaster';
import ExchangeRate from './ExchangeRate';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import PortOfLanding from './PortOfLanding';
import ContextWrapper from './CostingStageMaster/ContextWrapper';
import ProductContextWrapper from './ProductGroupMaster/ContextWrapper';
import DocumentTypeContextWrapper from './DocumentTypeMaster/ContextWrapper';
import ProductIdentifierContextWrapper from './ProductIdentifierMaster/ContextWrapper';
import * as userAction from '../UserSetting/store/User.action';
import DragDrogRearrange from '../../Components/DragDrogRearrange/DragDrogRearrange';
import DamGroupMaster from './DamGroupMaster/DamAttributeMaster';
import PlacementMasters from './PlacementMasterType';
import CompositionProcessMaster from './CompositionProcessMaster';
import BomComponentTypeMaster from './BomComponentTypeMaster';
import AutoGenerator from './AutoGenerator';
import MultiCustomAttribute from './MultiCustomAttribute/MultiCustomAttribute';
import CustomAttributeBomMaster from './CustomAttributesBomMaster/CustomAttributeBomMaster';
import CustomAttributeSubBomMaster from './CustomAttributesSubBomMaster/CustomAttributeSubBomMaster';
import { setSubBomAttributeSequence } from './Store/sub-bom-custom-attribute.action';
import LicensorMaster from './LicensorMaster/LicensorMaster';
import LicenseMaster from './LicenseMaster/LicenseMaster';
import LikenessMaster from './LikenessMaster/LikenessMaster';
import SubBrandMaster from './subBrandMaster';
import Incoterms from './Incoterms';
import ProductTypeProcessMaster from './ProductTypeProcessMaster';
import ModuleOrder from './ModuleOrder/ModuleOrder';
import ModuleItemsSidebar from './ModuleOrder/ModuleItemsSidebar';
import Loader from '../../Components/Utility/Loader/Loader';
import AssetLibraryTab from './AssetLibrary/AssetLibraryTab';
import SampleTypeGroupMaster from './SampleTypeGroupMaster';
import AdditionalVariablesMaster from './AdditionalVariablesMaster';
import { BOM_V2_ENABLED } from '../../constants/bom-v2.constants';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

const tempSTCopyObj = {
  name: 'Sent',
  isEmpty: false,
  isNew: true,
  isTrakingURL: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function SystemMasters() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights, sectionAccess },
  } = reducer;
  const { sample_status, sample_tracking, measurement_master, testTypeMaster, pcpCustomAttribute } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { CheckActionPermission } = useComponent();
  const sampleStatus = 'sample-status';
  const sampleTracking = 'sample-tracking';
  const supplierStatus = 'supplier-status-master';
  const [state, setState] = useState({
    seasonAccess: false,
    poSizeAccess: false,
    lengthAccess: false,
    unitsAccess: false,
    prodCompTypesAccess: false,
    prodStatusAccess: false,
    placementAccess: false,
    finishesAccess: false,
    specsAccess: false,
    samplesAccess: false,
    bomSubTypesAccess: false,
    brandAccess: false,
    categoryAccess: false,
    compositionAccess: false,
    customAttributeAccess: false,
    exchangeRatesAccess: false,
    productGroupsAccess: false,
    documentTypeAccess: false,
    productIdentifierAccess: false,
    OpenReArrange: false,
    rearrangeModal: '',
    rearrangeData: [],
    testTypeAccess: false,
    incotermsAccess: false,
    licensorAccess: false,
    licenceAccess: false,
    likenessAccess: false,
    subBrandAccess: false,
    compositionProcessAccess: false,
    bomComponentTypeProcessAccess: false,
    productTypeProcessesAccess: false,
  });

  const {
    brandAccess,
    seasonAccess,
    categoryAccess,
    poSizeAccess,
    lengthAccess,
    unitsAccess,
    prodCompTypesAccess,
    prodStatusAccess,
    bomSubTypesAccess,
    placementAccess,
    finishesAccess,
    compositionAccess,
    specsAccess,
    samplesAccess,
    exchangeRatesAccess,
    customAttributeAccess,
    productGroupsAccess,
    documentTypeAccess,
    productIdentifierAccess,
    testTypeAccess,
    incotermsAccess,
    licensorAccess,
    licenceAccess,
    likenessAccess,
    subBrandAccess,
    compositionProcessAccess,
    bomComponentTypeProcessAccess,
    productTypeProcessesAccess,
  } = state;
  const [showCIAccordian, setShowCIAccordian] = useState(false);
  const [showDASAccordian, setShowDASAccordian] = useState(false);
  const [showModuleOrderAccordian, setShowModuleOrderAccordian] = useState(false);
  const [moduleOrderConfigs, setModuleOrderConfigs] = useState([]);
  const [moduleOrderLoading, setModuleOrderLoading] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [moduleItems, setModuleItems] = useState([]);
  const [showModuleSidebar, setShowModuleSidebar] = useState(false);
  const [showAssetLibraryAccordian, setShowAssetLibraryAccordian] = useState(false);

  useEffect(() => {
    if (!isEmpty(sectionAccess)) {
      setState((prev) => ({
        ...prev,
        ...sectionAccess?.masters,
      }));
    }
  }, [sectionAccess]);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user?.role === 'User') {
      dispatch(userAction.fetchLogInRights({ section: 'all' }));
    }
  }, []);

  useEffect(() => {
    if (showModuleOrderAccordian) {
      setModuleOrderLoading(true);
      dispatch(action.getModuleOrderConfigs())
        .then((configs) => {
          setModuleOrderConfigs(Array.isArray(configs) ? configs : []);
        })
        .finally(() => setModuleOrderLoading(false));
    }
  }, [showModuleOrderAccordian, dispatch]);
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'finishes', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'finishes', 'delete');
  const { t } = useTranslation(['common', 'system-master']);
  const history = useHistory();
  const loggedInUserId = userInfo.userId;

  const [isLoadingST, setIsLoadingST] = useState(false);
  const [isSTUnique, setIsSTUnique] = useState(true);
  const [isSSUnique, setIsSSUnique] = useState(true);
  const [isMMUnique, setIsMMUnique] = useState(true);
  const [isLoadingSSM, setIsLoadingSSM] = useState(false);
  const [isLoadingMM, setIsLoadingMM] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isST, setIsST] = useState(false);
  const [isSSM, setIsSSM] = useState(false);
  const [isMM, setIsMM] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [buttonDownST, setButtonDownST] = useState(true);
  const [buttonDownSsm, setButtonDownSsm] = useState(true);
  const [buttonDownMm, setButtonDownMm] = useState(true);
  const [showST, setShowST] = useState(false);
  const [showSSM, setShowSSM] = useState(false);
  const [showMM, setShowMM] = useState(false);
  const [sTBtnDisable, setSTBtnDisable] = useState(false);
  const [ssmBtnDisable, setSsmBtnDisable] = useState(false);
  const [mmBtnDisable, setMmBtnDisable] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [deleteTitle, setDeleteTitle] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [activeInactiveTitle, setActiveInactiveTitle] = useState('');
  const [STData, setSTData] = useState([]);
  const [isUniqSTId, setIsUniqSTId] = useState('');
  const [brandValidationErrors, setBrandValidationErrors] = useState({});
  const [sTBtnDisableForBrands, setSTBtnDisableForBrands] = useState(false);
  const [sampleStatusData, setSampleStatusData] = useState([]);
  const [measurementData, setMeasurementData] = useState([]);
  const [isUniqSsId, setIsUniqSsId] = useState([]);
  const [isUniqMmId, setIsUniqMmId] = useState([]);
  const [documentMasterTypes, setDocumentMasterTypes] = useState({
    name: 'Specification Document Type',
    value: 'specification',
    type: 1,
  });
  const pcTypeCalled = async () => {
    const pcTypeParams = {
      isFromDocumentType: true,
      isAllRecord: true,
    };
    const ssParams = {
      loggedInUserId: userInfo?.userId,
    };
    await dispatch(action.getPCTypesAdminDetails(pcTypeParams, true));
    dispatch(action.getSupplierStatusDetails(ssParams));
  };

  const handleDropdownChange = async (value) => {
    setDocumentMasterTypes(value);
    await dispatch(action.clearDocumentMaster());

    if (value.value === 'specification') {
      await dispatch(action.fetchDocumentType({}, t));
    } else if (value.value === 'manual') {
      await dispatch(action.fetchManualDocumentType({}, t));
    } else {
      await dispatch(userAction.fetchUserDocumentsList({ fromMaster: 'true' }));
      await pcTypeCalled();
    }
  };

  useEffect(() => {
    const accorianDetails = async () => {
      await dispatch(action.getAccorianDetail());
      await dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true));
    };
    accorianDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSTData([...sample_tracking]);
    if (state?.rearrangeModal === 'sampleTracking') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...sample_tracking]?.filter((ele) => ele.name !== 'Requested'),
      }));
    }
  }, [sample_tracking, state?.rearrangeModal]);

  useEffect(() => {
    setSampleStatusData(sample_status);
    if (state?.rearrangeModal === 'sampleStatus') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...sample_status]?.slice(1),
      }));
    }
  }, [sample_status, state?.rearrangeModal]);

  useEffect(() => {
    setSampleStatusData(sample_status);
    if (state?.rearrangeModal === 'supplierStatus') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...sample_status],
      }));
    }
  }, [sample_status, state?.rearrangeModal]);

  useEffect(() => {
    setMeasurementData(measurement_master);
    if (state?.rearrangeModal === 'eCommSpecMaster') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...measurement_master],
      }));
    }
  }, [measurement_master, state?.rearrangeModal]);

  useEffect(() => {
    if (state?.rearrangeModal === 'testTypeMaster') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...testTypeMaster],
      }));
    }
  }, [testTypeMaster, state?.rearrangeModal]);

  useEffect(() => {
    if (state?.rearrangeModal === 'multiCustomAttribute') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...pcpCustomAttribute],
      }));
    }
  }, [pcpCustomAttribute, state?.rearrangeModal]);

  const handleDataChange = (data, setData, setIsUnique, setIsUniqId, setBtnDisable) => {
    const dataArray = [...data];
    const sampleArray = [];
    const sampleArrayIndex = [];
    dataArray.forEach((ele, ind) => {
      dataArray.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          sampleArray.push(ele);
          sampleArrayIndex.push(index);
        }
      });
    });
    if (!isEmpty(sampleArray)) {
      const arr = [...sampleArrayIndex];
      const remove = Math.min(...arr);
      const newArr = sampleArrayIndex.filter((ele) => ele !== remove);

      setIsUniqId([...newArr]);
    }
    setIsUnique(isEmpty(sampleArray));
    let isDisable = false;
    dataArray.forEach((element) => {
      if (isEmpty(element?.name?.trim())) {
        isDisable = true;
      }
    });
    setBtnDisable(isDisable);
    setData(dataArray);
  };

  const handleChanged = (event, i) => {
    const { name, value } = event.target;
    switch (name) {
      case 'sampleTracking': {
        const sampleTrack = [...STData];
        sampleTrack[i] = {
          ...sampleTrack[i],
          name: value,
          isEmpty: value === '',
        };
        setIsSTUnique(true);
        setIsUniqSTId([]);
        handleDataChange(sampleTrack, setSTData, setIsSTUnique, setIsUniqSTId, setSTBtnDisable);
        break;
      }
      case 'sampleStatusMaster': {
        const SSM = [...sampleStatusData];
        SSM[i] = {
          ...SSM[i],
          name: value,
          isEmpty: value === '',
        };
        setIsSSUnique(true);
        setIsUniqSsId([]);
        handleDataChange(SSM, setSampleStatusData, setIsSSUnique, setIsUniqSsId, setSsmBtnDisable);
        break;
      }
      case 'measurementMaster': {
        const MM = [...measurementData];
        MM[i] = {
          ...MM[i],
          name: value,
          isEmpty: value === '',
        };
        setIsMMUnique(true);
        setIsUniqMmId([]);
        handleDataChange(MM, setMeasurementData, setIsMMUnique, setIsUniqMmId, setMmBtnDisable);
        break;
      }
      default:
        history.push({
          pathname: '/masters',
          state: null,
        });
        break;
    }
  };

  const callApi = async (titleNames) => {
    switch (titleNames) {
      case 'sampleTracking':
        setButtonDownST(!buttonDownST);
        setIsLoadingST(true);
        setShowST(buttonDownST);
        // get api for Sample Tracking
        if (isEmpty(STData)) await dispatch(action.getSampleTrackingDetails());
        setIsLoadingST(false);
        break;
      case 'sampleStatusMaster':
        setButtonDownSsm(!buttonDownSsm);
        setIsLoadingSSM(true);
        setShowSSM(buttonDownSsm);
        await dispatch(action.getSampleStatusDetails({ loggedInUserId }));
        setIsLoadingSSM(false);
        break;
      case 'measurementMaster':
        setButtonDownMm(!buttonDownMm);
        setIsLoadingMM(true);
        setShowMM(buttonDownMm);

        if (isEmpty(measurementData)) await dispatch(action.getMeasurementDetails({ loggedInUserId }));
        setIsLoadingMM(false);
        break;

      default:
        history.push({
          pathname: '/masters',
          state: null,
        });
        break;
    }
  };

  const activeInactiveClicked = (id, title) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
    setActiveInactiveTitle(title);
  };

  const activeInactiveConfirmed = async () => {
    switch (activeInactiveTitle) {
      case 'sampleStatusMaster': {
        setIsLoadingConf(true);
        {
          let ssm = {};
          sampleStatusData.forEach((ele) => {
            if (ele._id === activeInactiveID) {
              ele.isActive = !ele.isActive;
              const data = {
                ...ele,
                loggedInUserId,
                title: sampleStatus,
              };
              ssm = data;
            }
          });
          await dispatch(action.setActiveInactive(ssm, t));
        }

        setIsLoadingConf(false);
        setShowConfirmationAD(false);
        setSampleStatusData([...sampleStatusData]);
        break;
      }
      case 'supplierStatusMaster': {
        setIsLoadingConf(true);
        {
          let ssm = {};
          sampleStatusData.forEach((ele) => {
            if (ele._id === activeInactiveID) {
              ele.isActive = !ele.isActive;
              const data = {
                ...ele,
                loggedInUserId,
                title: supplierStatus,
              };
              ssm = data;
            }
          });
          await dispatch(action.setActiveInactive(ssm, t));
        }

        setIsLoadingConf(false);
        setShowConfirmationAD(false);
        setSampleStatusData([...sampleStatusData]);
        break;
      }
      case 'sampleTracking': {
        setIsLoadingConf(true);
        {
          let st = {};
          STData.forEach((ele) => {
            if (ele._id === activeInactiveID) {
              ele.isActive = !ele.isActive;
              const data = {
                ...ele,
                loggedInUserId,
                title: sampleTracking,
              };
              st = data;
            }
          });
          await dispatch(action.setActiveInactive(st, t));
        }

        setIsLoadingConf(false);
        setShowConfirmationAD(false);
        setSTData([...STData]);
        break;
      }
      case 'measurementMaster': {
        setIsLoadingConf(true);
        {
          let mm = {};
          measurementData.forEach((ele) => {
            if (ele._id === activeInactiveID) {
              ele.isActive = !ele.isActive;
              const data = {
                ...ele,
                loggedInUserId,
                title: 'measurement',
              };
              mm = data;
            }
          });
          await dispatch(action.setActiveInactive(mm, t));
        }

        setIsLoadingConf(false);
        setShowConfirmationAD(false);
        setMeasurementData([...measurementData]);
        break;
      }
      default:
        history.push({
          pathname: '/masters',
          state: null,
        });
        break;
    }
  };

  const handleDelete = (id, title) => {
    if (typeof id === 'number' || id === '') {
      switch (title) {
        case 'sampleStatusMaster': {
          sampleStatusData.splice(id, 1);
          {
            let finalDelSS = false;
            sampleStatusData.forEach((ssmElement) => {
              if (isEmpty(ssmElement?.name?.trim())) {
                finalDelSS = true;
              }
            });
            setSsmBtnDisable(finalDelSS);
          }

          setIsUniqSsId([]);
          setIsSSUnique(true);
          setSampleStatusData([...sampleStatusData]);

          break;
        }
        case 'sampleTracking': {
          STData.splice(id, 1);
          {
            let finalDelST = false;
            STData.forEach((stElement) => {
              if (isEmpty(stElement?.name.trim())) {
                finalDelST = true;
              }
            });
            setSTBtnDisable(finalDelST);
          }

          setIsUniqSTId([]);
          setIsSTUnique(true);
          setSTData([...STData]);
          break;
        }
        case 'measurementMaster': {
          measurementData.splice(id, 1);
          let finalDelMM = false;
          measurementData.forEach((mmElement) => {
            if (isEmpty(mmElement?.name?.trim())) {
              finalDelMM = true;
            }
          });
          setMmBtnDisable(finalDelMM);
          setIsUniqMmId([]);
          setIsMMUnique(true);
          setMeasurementData([...measurementData]);
          break;
        }
        default:
          history.push({
            pathname: '/masters',
            state: null,
          });
          break;
      }
    } else {
      setDeleteId(id);
      setDeleteTitle(title);
      setShowConfirmation(true);
    }
  };

  const checkSTCheckBox = (ele) => {
    ele.isChecked = !ele?.isChecked;
  };

  const handleCheckboxST = (e) => {
    STData.forEach((ele) => {
      if (ele._id === e.target.value) {
        checkSTCheckBox(ele);
      }
    });
    setSTData([...STData]);
  };

  // Brand selection change handler
  const handleBrandSelectionChange = (index, selectedBrands) => {
    const updatedSTData = [...STData];
    // Convert multiselect format to ObjectId array for backend
    const brandIds = selectedBrands.map((brand) => brand.value);
    updatedSTData[index] = {
      ...updatedSTData[index],
      brands: brandIds,
    };
    setSTData(updatedSTData);

    // Clear validation error for this item if brands are selected
    if (selectedBrands.length > 0) {
      const newErrors = { ...brandValidationErrors };
      delete newErrors[index];
      setBrandValidationErrors(newErrors);
    }

    // Validate all items for brand requirements
    validateBrandSelections(updatedSTData);
  };

  // Brand validation function
  const validateBrandSelections = (data = STData) => {
    const errors = {};
    let hasErrors = false;

    data.forEach((item, index) => {
      if (item?.name?.trim() && (!item?.brands || item?.brands?.length === 0)) {
        errors[index] = t('SAMPLE_TRACK.BRANDS_REQUIRED');
        hasErrors = true;
      }
    });

    setBrandValidationErrors(errors);
    setSTBtnDisableForBrands(hasErrors);
    return !hasErrors;
  };

  const handleSampleStatusAndMeasurement = (i, status) => {
    sampleStatusData.forEach((ele, index) => {
      if (index === i) {
        ele.statusColor = status;
      }
    });
    setSampleStatusData([...sampleStatusData]);
  };

  useEffect(() => {
    const array = [];
    sampleStatusData.forEach((ele, index) => {
      sampleStatusData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsSSUnique(isEmpty(array));
      setIsUniqSsId([]);
    }
  }, [sampleStatusData]);

  useEffect(() => {
    const array = [];
    STData.forEach((ele, index) => {
      STData.forEach((obj, places1) => {
        if (index !== places1 && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsSTUnique(isEmpty(array));
      setIsUniqSTId([]);
    }

    // Validate brand selections when STData changes
    validateBrandSelections(STData);
  }, [STData]);

  const deleteConfirmed = async () => {
    switch (deleteTitle) {
      case 'sampleStatusMaster': {
        setIsLoadingConf(true);
        const sampleStatusMasterParams = {
          loggedInUserId,
          sampleStatusId: deleteId,
          title: sampleStatus,
        };
        await dispatch(action.deleteFromSystemMasters(sampleStatusMasterParams, t));
        setIsLoadingConf(false);
        setShowConfirmation(false);
        setSampleStatusData([...sample_status]);
        const ssParams = {
          loggedInUserId,
        };
        await dispatch(action.getSampleStatusDetails(ssParams));
        break;
      }
      case 'supplierStatusMaster': {
        setIsLoadingConf(true);
        const supplierStatusMasterParams = {
          loggedInUserId,
          supplierStatusId: deleteId,
          title: supplierStatus,
        };
        await dispatch(action.deleteFromSystemMasters(supplierStatusMasterParams, t));
        setIsLoadingConf(false);
        setShowConfirmation(false);
        setSampleStatusData([...sample_status]);
        const ssParams = {
          loggedInUserId,
        };
        await dispatch(action.getSupplierStatusDetails(ssParams));
        break;
      }
      case 'sampleTracking': {
        setIsLoadingConf(true);
        const sampleTrackingParams = {
          loggedInUserId,
          sampleTrackingId: deleteId,
          title: sampleTracking,
        };
        await dispatch(action.deleteFromSystemMasters(sampleTrackingParams, t));
        setIsLoadingConf(false);
        setShowConfirmation(false);
        setSTData([...sample_tracking]);
        const stParams = {
          loggedInUserId,
        };
        await dispatch(action.getSampleTrackingDetails(stParams));
        break;
      }
      case 'measurementMaster': {
        setIsLoadingConf(true);
        const measurementParams = {
          loggedInUserId,
          measurementId: deleteId,
          title: t('SYSTEM_MASTER.MEASUREMENT'),
        };
        await dispatch(action.deleteFromSystemMasters(measurementParams, t));
        setIsLoadingConf(false);
        setShowConfirmation(false);
        setMeasurementData([...measurement_master]);
        const mmParams = {
          loggedInUserId,
        };
        await dispatch(action.getMeasurementDetails(mmParams));
        break;
      }
      default:
        history.push({
          pathname: '/masters',
          state: null,
        });
        break;
    }
  };

  const addSampleTracking = async () => {
    if (!showST) {
      setButtonDownST(!buttonDownST);
      setIsLoadingST(true);
      setShowST(buttonDownST);
      // Post api for Sample Tracking
      const stParams = {
        loggedInUserId,
      };
      if (isEmpty(STData)) await dispatch(action.getSampleTrackingDetails(stParams));

      setIsLoadingST(false);
    } else if (!isEmpty(STData)) {
      setSTData([...STData, tempObj]);
    } else {
      setSTData([tempObj]);
    }
  };

  const copySampleTracking = async () => {
    if (!isEmpty(STData)) {
      setSTData([...STData, tempSTCopyObj]);
    } else {
      setSTData([tempSTCopyObj]);
    }
  };

  const saveST = async () => {
    setIsST(true);
    if (!isEmpty(STData)) {
      const emptyField = await STData.filter((stitem) => stitem.name === null || stitem.name === '');

      if (isEmpty(emptyField)) {
        // Validate brand selections before saving
        const isBrandValidationPassed = validateBrandSelections(STData);

        if (isBrandValidationPassed) {
          const data = STData.map((stobj) => {
            return {
              ...stobj,
              name: stobj?.name?.trim(),
              brands: stobj?.brands || [],
            };
          });
          // paramsFor saving sample Tracking
          const stSaveParams = {
            names: JSON.stringify(data),
            title: sampleTracking,
          };
          await dispatch(action.saveToSystemMaster(stSaveParams, t));

          const stParams = {
            loggedInUserId,
          };
          await dispatch(action.getSampleTrackingDetails(stParams));
          // Clear brand validation errors after successful save
          setBrandValidationErrors({});
        }
        // post API
      } else {
        const newState = STData.map((stobj) => (stobj?.isEmpty === false && stobj.name === null ? { ...stobj, isEmpty: true } : stobj));
        setSTData(newState);
      }
    }
    setIsST(false);
  };

  const addSampleStatus = async () => {
    if (!showSSM) {
      setButtonDownSsm(!buttonDownSsm);
      setIsLoadingSSM(true);
      setShowSSM(buttonDownSsm);
      const ssParams = {
        loggedInUserId,
      };

      if (isEmpty(sampleStatusData)) await dispatch(action.getSampleStatusDetails(ssParams));
      setIsLoadingSSM(false);
    } else if (!isEmpty(sampleStatusData)) {
      setSampleStatusData([...sampleStatusData, tempObj]);
    } else {
      setSampleStatusData([tempObj]);
    }
  };

  const addMeasurement = async () => {
    if (!showMM) {
      setButtonDownMm(!buttonDownMm);
      setIsLoadingMM(true);
      setShowMM(buttonDownMm);
      const mmParams = {
        loggedInUserId,
      };

      if (isEmpty(measurementData)) await dispatch(action.getMeasurementDetails(mmParams));
      setIsLoadingMM(false);
    } else if (!isEmpty(measurementData)) {
      setMeasurementData([...measurementData, tempObj]);
    } else {
      setMeasurementData([tempObj]);
    }
  };

  const saveSampleStatus = async () => {
    setIsSSM(true);
    if (!isEmpty(sampleStatusData)) {
      const emptyField = await sampleStatusData.filter((ssitem) => ssitem.name === null || ssitem.name === '');

      if (isEmpty(emptyField)) {
        const data = sampleStatusData.map((ssobj) => {
          return { ...ssobj, name: ssobj?.name?.trim() };
        });
        const sampleParams = {
          title: sampleStatus,
          loggedInUserId,
          names: JSON.stringify(data),
        };
        await dispatch(action.saveToSystemMaster(sampleParams, t));
        const ssParams = {
          loggedInUserId,
        };
        await dispatch(action.getSampleStatusDetails(ssParams));

        // post API
      } else {
        const newState = sampleStatusData.map((posobj) => (posobj?.isEmpty === false && posobj.name === null ? { ...posobj, isEmpty: true } : posobj));
        setSampleStatusData(newState);
      }
    }
    setIsSSM(false);
  };

  const saveMeasurement = async () => {
    setIsMM(true);

    if (!isEmpty(measurementData)) {
      const emptyField = await measurementData.filter((mmitem) => mmitem.name === null || mmitem.name === '');

      if (isEmpty(emptyField)) {
        const data = measurementData.map((ssobj) => {
          return { ...ssobj, name: ssobj?.name?.trim() };
        });
        const mmParams = {
          title: t('SYSTEM_MASTER.MEASUREMENTS'),
          loggedInUserId,
          names: JSON.stringify(data),
        };

        await dispatch(action.saveToSystemMaster(mmParams, t));
        const meausurementParams = {
          loggedInUserId,
        };
        await dispatch(action.getMeasurementDetails(meausurementParams));
        // post API
      } else {
        const newState = measurementData.map((mmObj) => (mmObj?.isEmpty === false && mmObj.name === null ? { ...mmObj, isEmpty: true } : mmObj));
        setMeasurementData(newState);
      }
    }
    setIsMM(false);
  };

  const btnCall = (name) => {
    switch (name) {
      case buttonDownSsm:
        return buttonDownSsm === false ? <i className="icon-new-up" /> : <i className="icon-new-down" />;
      case buttonDownST:
        return buttonDownST === false ? <i className="icon-new-up" /> : <i className="icon-new-down" />;
      case buttonDownMm:
        return buttonDownMm === false ? <i className="icon-new-up" /> : <i className="icon-new-down" />;
      default:
        return <i className="icon-new-down" />;
    }
  };

  const renderTooltipOpenClosessm = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownSsm ? t('SYSTEM_MASTER.CLOSE') : t('SYSTEM_MASTER.OPEN')}
    </Tooltip>
  );
  const renderTooltipOpenCloseST = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownST ? t('SYSTEM_MASTER.CLOSE') : t('SYSTEM_MASTER.OPEN')}
    </Tooltip>
  );
  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('SYSTEM_MASTER.DELETE')}
    </Tooltip>
  );
  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('SYSTEM_MASTER.ACTIVE_INACTIVE')}
    </Tooltip>
  );
  const renderCopy = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('SYSTEM_MASTER.COPY')}
    </Tooltip>
  );

  const OpenReArrangeFunction = async (masterName) => {
    await dispatch(action.clearRearrangeMaster());
    switch (masterName) {
      case 'sampleTracking':
        await dispatch(action.getSampleTrackingDetails({ loggedInUserId }));
        break;
      case 'sampleStatus':
        await dispatch(action.getSampleStatusDetails({ loggedInUserId }));
        break;
      case 'eCommSpecMaster':
        await dispatch(action.getMeasurementDetails({ loggedInUserId }));
        break;
      case 'ProductGroup':
        await dispatch(action.fetchProductGroup(t));
        break;
      case 'documentType':
        await dispatch(action.fetchDocumentType({}, t));
        break;
      case 'coastingStage':
        await dispatch(action.getCostingStageList({ loggedInUserId }));
        break;
      case 'productIdentifier':
        await dispatch(action.fetchProductIdentifier(t));
        break;
      case 'customAttribute':
        await Promise.all([dispatch(action.getCustomAttributeFreeText()), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'testTypeMaster':
        await dispatch(action.fetchTestTypeMaster());
        break;
      case 'damDropdownAttribute':
        await Promise.all([dispatch(action.getDamAttributeFreeText({ type: 'dropdown' })), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'supplierStatus':
        await dispatch(action.getSupplierStatusDetails({ loggedInUserId }));
        break;

      case 'damTextAttribute':
        await Promise.all([dispatch(action.getDamAttributeFreeText({ type: 'text' })), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'manualDocumentType':
        await dispatch(action.fetchManualDocumentType({}, t));
        break;
      case 'multiCustomAttribute':
        await Promise.all([dispatch(action.getMultiCustomAttribute()), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'customBomAttribute':
        await Promise.all([dispatch(action.getBomCustomAttribute())]);
        break;
      case 'subBomCustomAttribute':
        break;
      default:
        break;
    }
    setState((prev) => ({ ...prev, OpenReArrange: true, rearrangeModal: masterName }));
  };
  const toggleRearrangeModal = () => {
    setState((prev) => ({ ...prev, OpenReArrange: false, rearrangeData: [], rearrangeModal: '' }));
  };

  const handleSaveSequence = async ({ sequence }) => {
    switch (state?.rearrangeModal) {
      case 'sampleTracking':
        await dispatch(action.setSampleTrackingSequence(sequence, t));
        await dispatch(action.getSampleTrackingDetails({ loggedInUserId }));
        break;
      case 'sampleStatus':
        await dispatch(action.setSampleStatusSequence(sequence, t));
        await dispatch(action.getSampleStatusDetails({ loggedInUserId }));
        break;
      case 'eCommSpecMaster':
        await dispatch(action.setMeasurementSequence(sequence, t));
        await dispatch(action.getMeasurementDetails({ loggedInUserId }));
        break;
      case 'ProductGroup':
        await dispatch(action.setProductGroupSequence(sequence, t));
        await dispatch(action.fetchProductGroup(t));
        break;
      case 'documentType':
        await dispatch(action.setDocumentTypeSequence(sequence, t));
        await dispatch(action.fetchDocumentType({}, t));
        break;
      case 'coastingStage':
        await dispatch(action.setCostingStageSequence(sequence, t));
        await dispatch(action.getCostingStageList({ loggedInUserId }));
        break;
      case 'productIdentifier':
        await dispatch(action.setProductIdentifierSequence(sequence, t));
        await dispatch(action.fetchProductIdentifier(t));
        break;
      case 'customAttribute':
        await dispatch(action.setCustomAttributeSequence(sequence, t));
        await Promise.all([dispatch(action.getCustomAttributeFreeText()), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'testTypeMaster':
        await dispatch(action.setTestTypeSequence(sequence, t));
        await dispatch(action.fetchTestTypeMaster());
        break;
      case 'damDropdownAttribute':
        await dispatch(action.setDamAttributeSequence(sequence, t));
        await Promise.all([dispatch(action.getDamAttributeFreeText({ type: 'dropdown' })), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'damTextAttribute':
        await dispatch(action.setDamAttributeSequence(sequence, t));
        await Promise.all([dispatch(action.getDamAttributeFreeText({ type: 'text' })), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
        break;
      case 'supplierStatus':
        await dispatch(action.setSupplierStatusSequence(sequence, t));
        await dispatch(action.getSupplierStatusDetails({ loggedInUserId }));
        break;
      case 'manualDocumentType':
        await dispatch(action.setManualDocumentTypeSequence(sequence, t));
        await dispatch(action.fetchManualDocumentType({}, t));
        break;
      case 'multiCustomAttribute':
        await dispatch(action.setMultiCustomAttributeSequence(sequence, t));
        await dispatch(action.getMultiCustomAttribute());
      case 'customBomAttribute':
        await dispatch(action.setCustomBomAttributeSequence(sequence, t));
        await Promise.all([dispatch(action.getBomCustomAttribute())]);
        break;
      case 'subBomCustomAttribute':
        await dispatch(setSubBomAttributeSequence(sequence, t));
        break;
      default:
        break;
    }
    toggleRearrangeModal();
  };

  const handleModuleClick = async (module) => {
    setSelectedModule(module);
    try {
      const items = await dispatch(action.getModuleOrderItems(module.id));
      if (items && items.length > 0) {
        setModuleItems(items);
      } else {
        setModuleItems(
          module.items.map((item, index) => ({
            _id: `item-${index}`,
            name: item,
            sequence: index + 1,
          })),
        );
      }
      setShowModuleSidebar(true);
    } catch (error) {
      setModuleItems(
        module.items.map((item, index) => ({
          _id: `item-${index}`,
          name: item,
          sequence: index + 1,
        })),
      );
      setShowModuleSidebar(true);
    }
  };

  const handleModuleSequenceSave = async (moduleId, sequence) => {
    await dispatch(action.setModuleOrderSequence({ moduleId, sequence }, t));
    const items = await dispatch(action.getModuleOrderItems(moduleId));
    if (items && items.length > 0) {
      setModuleItems(items);
    }
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('SYSTEM_MASTER.SYSTEM_MASTERS', { ns: 'common' })}</h4>
        </div>
      </div>
      <Container className="sticky-header-inner-scroll" fluid>
        <Accordion className="mb-4 master-accordian mt-4">
          <Card>
            <Card.Header>
              <div className="title-container">
                <p>{t('SYSTEM_MASTER.CORE_INFORMATION')}</p>
              </div>
              <div className="action-title-btns single-btn">
                <button onClick={() => setShowCIAccordian(!showCIAccordian)} type="button">
                  {showCIAccordian ? <i className="icon-new-up" /> : <i className="icon-new-down" />}
                </button>
              </div>
            </Card.Header>
            {showCIAccordian && (
              <Card.Body>
                <Container fluid className="py-3">
                  <Row>
                    <Col md={4}>
                      {brandAccess && <BrandMaster />}
                      {categoryAccess && <Category1Master />}
                      {categoryAccess && <Category4Master />}
                      {lengthAccess && <LengthMaster />}
                      {samplesAccess && <OtherSampleMaster />}
                      {prodStatusAccess && <ProductStatusMaster />}
                      {samplesAccess && (
                        <SampleStatus
                          addSampleStatus={addSampleStatus}
                          ssmBtnDisable={ssmBtnDisable}
                          isSSUnique={isSSUnique}
                          renderTooltipOpenClosePsm={renderTooltipOpenClosessm}
                          callApi={callApi}
                          buttonDownSsm={buttonDownSsm}
                          btnCall={btnCall}
                          showSSM={showSSM}
                          isLoadingSSM={isLoadingSSM}
                          sampleStatusData={sampleStatusData}
                          handleCheckboxST={handleCheckboxST}
                          handleChanged={handleChanged}
                          renderTooltipActiveInactive={renderTooltipActiveInactive}
                          activeInactiveClicked={activeInactiveClicked}
                          renderTooltipDelete={renderTooltipDelete}
                          handleDelete={handleDelete}
                          saveSampleStatus={saveSampleStatus}
                          isSSM={isSSM}
                          handleSampleStatus={handleSampleStatusAndMeasurement}
                          isUniqueId={isUniqSsId}
                          OpenReArrangeFunction={OpenReArrangeFunction}
                        />
                      )}
                      {customAttributeAccess && (
                        <CustomAttributeMaster OpenReArrangeFunction={OpenReArrangeFunction} parentState={state} parentSetState={setState} />
                      )}
                      {customAttributeAccess && <PartnerOverviewCustomAttributes />}
                      {specsAccess && (
                        <MeasurementMaster
                          addMeasurement={addMeasurement}
                          mmBtnDisable={mmBtnDisable}
                          isMMUnique={isMMUnique}
                          renderTooltipOpenClosePsm={renderTooltipOpenClosessm}
                          callApi={callApi}
                          buttonDownMm={buttonDownMm}
                          btnCall={btnCall}
                          showMM={showMM}
                          isLoadingMM={isLoadingMM}
                          measurementData={measurementData}
                          handleCheckboxST={handleCheckboxST}
                          handleChanged={handleChanged}
                          renderTooltipActiveInactive={renderTooltipActiveInactive}
                          activeInactiveClicked={activeInactiveClicked}
                          renderTooltipDelete={renderTooltipDelete}
                          handleDelete={handleDelete}
                          saveMeasurement={saveMeasurement}
                          isMM={isMM}
                          isUniqueId={isUniqMmId}
                          OpenReArrangeFunction={OpenReArrangeFunction}
                        />
                      )}
                      {productGroupsAccess && <ProductContextWrapper OpenReArrangeFunction={OpenReArrangeFunction} state={state} setState={setState} />}
                      {productIdentifierAccess && (
                        <ProductIdentifierContextWrapper OpenReArrangeFunction={OpenReArrangeFunction} state={state} setState={setState} />
                      )}
                      <AutoGenerator />
                      {(userInfo?.role === 'Admin' || licenceAccess) && <LicenseMaster />}
                      {(userInfo?.role === 'Admin' || productTypeProcessesAccess) && <ProductTypeProcessMaster />}
                    </Col>
                    <Col md={4}>
                      {(userInfo?.role === 'Admin' || subBrandAccess) && <SubBrandMaster />}
                      {categoryAccess && <Category2Master />}
                      {prodCompTypesAccess && <ProductComponentTypeMaster />}
                      {poSizeAccess && <POSizeMaster />}
                      {unitsAccess && <UnitsMaster />}
                      {finishesAccess && <FinalMaster />}
                      {placementAccess && <PlacementMasters />}
                      <ContextWrapper OpenReArrangeFunction={OpenReArrangeFunction} state={state} setState={setState} />
                      {testTypeAccess && <TestTypeMaster OpenReArrangeFunction={OpenReArrangeFunction} state={state} setState={setState} />}
                      <CustomAttributeBomMaster parentState={state} parentSetState={setState} OpenReArrangeFunction={OpenReArrangeFunction} />
                      {(userInfo?.role === 'Admin' || incotermsAccess) && <Incoterms />}
                      {(userInfo?.role === 'Admin' || likenessAccess) && <LikenessMaster />}
                      {(userInfo?.role === 'Admin' || bomComponentTypeProcessAccess) && <BomComponentTypeMaster />}
                    </Col>
                    <Col md={4}>
                      {seasonAccess && <SeasonMaster />}
                      {categoryAccess && <Category3Master />}
                      {compositionAccess && <CompositionMaster />}

                      {samplesAccess && <SampleTypeGroupMaster />}

                      {samplesAccess && <AdditionalVariablesMaster />}

                      {bomSubTypesAccess && <BomSubTypeMaster />}
                      <BomSubComponentTypeMaster />

                      {samplesAccess && (
                        <SampleTracking
                          addSampleTracking={addSampleTracking}
                          sTBtnDisable={sTBtnDisable || sTBtnDisableForBrands}
                          isSTUnique={isSTUnique}
                          renderTooltipOpenCloseCat3={renderTooltipOpenCloseST}
                          callApi={callApi}
                          buttonDownST={buttonDownST}
                          btnCall={btnCall}
                          showST={showST}
                          isLoadingST={isLoadingST}
                          STData={STData}
                          handleCheckboxST={handleCheckboxST}
                          handleChanged={handleChanged}
                          renderCopy={renderCopy}
                          renderTooltipActiveInactive={renderTooltipActiveInactive}
                          activeInactiveClicked={activeInactiveClicked}
                          renderTooltipDelete={renderTooltipDelete}
                          handleDelete={handleDelete}
                          saveST={saveST}
                          isST={isST}
                          copySampleTracking={copySampleTracking}
                          isUniqueId={isUniqSTId}
                          masterAddEditAccess={MasterAddEditAccess}
                          masterDeleteAccess={MasterDeleteAccess}
                          OpenReArrangeFunction={OpenReArrangeFunction}
                          onBrandSelectionChange={handleBrandSelectionChange}
                          brandValidationErrors={brandValidationErrors}
                        />
                      )}
                      {exchangeRatesAccess && <ExchangeRate />}
                      {placementAccess && <PortOfLanding renderTooltipDelete={renderTooltipDelete} />}
                      {documentTypeAccess && (
                        <DocumentTypeContextWrapper
                          handleDropdownChange={handleDropdownChange}
                          OpenReArrangeFunction={OpenReArrangeFunction}
                          documentMasterTypes={documentMasterTypes}
                          state={state}
                          setState={setState}
                        />
                      )}
                      <MultiCustomAttribute OpenReArrangeFunction={OpenReArrangeFunction} parentState={state} parentSetState={setState} />
                      {(userInfo?.role === 'Admin' || licensorAccess) && <LicensorMaster />}
                      {(userInfo?.role === 'Admin' || compositionProcessAccess) && <CompositionProcessMaster />}
                      {BOM_V2_ENABLED && (
                        <CustomAttributeSubBomMaster parentState={state} parentSetState={setState} OpenReArrangeFunction={OpenReArrangeFunction} />
                      )}
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            )}
          </Card>
        </Accordion>
        <Accordion className="mb-4 master-accordian mt-4">
          <Card>
            <Card.Header>
              <div className="title-container">
                <p>Digital Asset Specifics</p>
              </div>
              <div className="action-title-btns single-btn">
                <button onClick={() => setShowDASAccordian(!showDASAccordian)} type="button">
                  {showDASAccordian ? <i className="icon-new-up" /> : <i className="icon-new-down" />}
                </button>
              </div>
            </Card.Header>
            {showDASAccordian && (
              <Card.Body>
                <Container fluid className="py-3">
                  <Row>
                    <Col>
                      <DamGroupMaster OpenReArrangeFunction={OpenReArrangeFunction} parentState={state} parentSetState={setState} attName="dropdown" />
                    </Col>

                    <Col>
                      <DamGroupMaster OpenReArrangeFunction={OpenReArrangeFunction} parentState={state} parentSetState={setState} attName="text" />
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            )}
          </Card>
        </Accordion>

        {/* ACCORDION 3: ASSET LIBRARY */}
        <Accordion className="mb-4 master-accordian mt-4">
          <Card>
            <Card.Header>
              <div className="title-container">
                <p>{t('systemMaster:ASSET_LIBRARY.SYSTEM_MASTER_TAB')}</p>
              </div>
              <div className="action-title-btns single-btn">
                <button onClick={() => setShowAssetLibraryAccordian(!showAssetLibraryAccordian)} type="button">
                  {showAssetLibraryAccordian ? <i className="icon-new-up" /> : <i className="icon-new-down" />}
                </button>
              </div>
            </Card.Header>
            {showAssetLibraryAccordian && (
              <Card.Body>
                <Container fluid className="py-3">
                  <AssetLibraryTab />
                </Container>
              </Card.Body>
            )}
          </Card>
        </Accordion>

        <Accordion className="mb-4 master-accordian mt-4">
          <Card>
            <Card.Header>
              <div className="title-container">
                <p>{t('MODULE_ORDER.MODULE_ORDER', { ns: 'system-master' })}</p>
              </div>
              <div className="action-title-btns single-btn">
                <button onClick={() => setShowModuleOrderAccordian(!showModuleOrderAccordian)} type="button">
                  {showModuleOrderAccordian ? <i className="icon-new-up" /> : <i className="icon-new-down" />}
                </button>
              </div>
            </Card.Header>
            {showModuleOrderAccordian && (
              <Card.Body>
                <Container fluid className="py-3">
                  <Row>
                    <Col>
                      {moduleOrderLoading ? (
                        <div className="text-center py-4">
                          <Loader />
                        </div>
                      ) : (
                        <ModuleOrder
                          onModuleClick={handleModuleClick}
                          modules={moduleOrderConfigs.map((c) => ({
                            id: c.moduleId,
                            name: c.moduleName || c.moduleId,
                            items: (c.items || []).sort((a, b) => (a.sequence || 0) - (b.sequence || 0)).map((i) => i.itemName),
                          }))}
                        />
                      )}
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            )}
          </Card>
        </Accordion>
      </Container>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('SYSTEM_MASTER.DELETE_FROM_MASTER')}
          message={t('SYSTEM_MASTER.ARE_YOU_SURE_WANT_DELETE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}

      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('SYSTEM_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('SYSTEM_MASTER.ARE_U_SURE_ACTIVATE_DEACTIVATE_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
      {state.OpenReArrange && (
        <DragDrogRearrange
          isShow={state.OpenReArrange}
          saveSequence={handleSaveSequence}
          isToggle={toggleRearrangeModal}
          itemList={state?.rearrangeData}
          forSystemMaster
        />
      )}
      <ModuleItemsSidebar
        show={showModuleSidebar}
        onHide={() => setShowModuleSidebar(false)}
        module={selectedModule}
        moduleItems={moduleItems}
        onSaveSequence={handleModuleSequenceSave}
      />
    </>
  );
}

export default SystemMasters;
